<div class="d-flex flex-column border border-light">
  <button (click)="openModal()" class="btn btn-primary">
    {{ "assignments.participants.contactParticipants" | transloco }}
  </button>
</div>
